import type { IActivityDurationFields } from "@/forms/AddActivityForm/ActivityDuration";
import { DEFAULT_ACTIVITY_DURATION_OPTION } from "@/forms/AddActivityForm/activityDurationModels";
import type { IInvoicingCodesPickerFields } from "@/forms/AddActivityForm/InvoicingPicker";
import type { ITitleInputFields } from "@/forms/AddActivityForm/TitleInput";
import { generateRandomUUID } from "@/Utils/UniqueId";

export type ActivityRowFields = IActivityDurationFields &
  ITitleInputFields &
  IInvoicingCodesPickerFields & {
    activityId: string;
    description?: string;
  };

export const newActivityRow = (): ActivityRowFields => ({
  activityId: generateRandomUUID(),
  title: "",
  description: "",
  durationOption: DEFAULT_ACTIVITY_DURATION_OPTION,
  customDuration: null,
  customDurationUnit: null,
  procedureCodes: [],
  productCodes: [],
});
